function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 2H6.5V4H3V7.5H1V2ZM5.5 16.5L5.5 7.5H7.5L7.5 16.5H5.5ZM16.5 16.5V7.5H18.5V16.5H16.5ZM11 7.5V16.5H13V7.5H11ZM1 16.5V22H6.5L6.5 20H3L3 16.5H1ZM23 22H17.5V20H21V16.5L23 16.5V22ZM23 7.5V2H17.5V4L21 4V7.5L23 7.5Z",
  fill: "#666666"
});

var SvgBarcodeIcon = function SvgBarcodeIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBarcodeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/barcode-icon.50690cda.svg";
export { ForwardRef as ReactComponent };